import { marketPolicyType } from '@/shared/enums/marketPolicyType'

export const sidebarItems = [
  {
    label: 'Dashboard',
    icon: 'pi pi-chart-pie',
    path: 'Dashboard'
  },
  {
    label: 'Tracking',
    icon: 'pi pi-map',
    path: 'MonitoringOrder',
    can: [marketPolicyType.VIEW_MONITORING]
  },
  {
    label: 'Monitoring Two',
    icon: 'pi pi-map',
    path: 'MonitoringTwoOrder',
    can: [marketPolicyType.VIEW_MONITORING]
  },
  // {
  //   label: 'Live Order',
  //   icon: 'pi pi-table',
  //   path: 'Lives',
  //   can: [marketPolicyType.VIEW_LIVE_ORDERS, marketPolicyType.VIEW_PACKAGES]
  // },
  {
    label: 'Live Order V2',
    icon: 'pi pi-table',
    path: 'LivesV2',
    can: [marketPolicyType.VIEW_LIVE_ORDERS, marketPolicyType.VIEW_PACKAGES]
  },
  {
    label: 'Chat',
    icon: 'pi pi-comment',
    path: 'Chat',
    can: [marketPolicyType.VIEW_SUPPORT_MESSAGES]
  },
  {
    label: 'Orders',
    icon: 'pi pi-shopping-cart',
    key: '1',
    can: [
      marketPolicyType.VIEW_ORDERS,
      marketPolicyType.VIEW_PANEL_SETTINGS,
      marketPolicyType.VIEW_USER_ORDER_RATE_REASONS,
      marketPolicyType.VIEW_CANCEL_ORDER_REASONS,
      marketPolicyType.VIEW_CANCEL_MEAL_REASONS
    ],
    items: [
      {
        label: 'Order List',
        path: 'OrderList',
        can: [marketPolicyType.VIEW_ORDERS]
      },

      {
        label: 'Order Rate',
        path: 'OrderRate',
        can: [marketPolicyType.VIEW_USER_ORDER_RATES]
      },
      {
        label: 'Order Rate Reasons',
        path: 'OrderRateReasonList',
        can: [marketPolicyType.VIEW_USER_ORDER_RATE_REASONS]
      },
      {
        label: 'Order Cancellation Policies',
        path: 'OrderCancellationPolicyList',
        can: [marketPolicyType.VIEW_PANEL_SETTINGS]
      },
      {
        label: 'Order Cancellation Policy History',
        path: 'OrderCancellationPolicyHistory',
        can: [marketPolicyType.VIEW_PANEL_SETTINGS]
      },
      {
        label: 'Cancel Order Reasons',
        path: 'CancelOrderReason',
        can: [marketPolicyType.VIEW_CANCEL_ORDER_REASONS]
      }
    ]
  },
  {
    label: 'Meals',
    icon: 'pi pi-bookmark',
    key: '13',
    can: [marketPolicyType.VIEW_CANCEL_MEAL_REASONS, marketPolicyType.VIEW_COMPANIES],
    items: [
      {
        label: 'Meal List',
        path: 'MealList'
      },
      {
        label: 'Scheduled MyMeal Programs',
        path: 'ScheduledProgramList',
        can: [marketPolicyType.VIEW_COMPANIES]
      },
      {
        label: 'Meal Category',
        path: 'MealCategoryList'
      },
      {
        label: 'Cancel Meal Reason',
        path: 'CancelMealReason',
        can: [marketPolicyType.VIEW_CANCEL_MEAL_REASONS]
      },
      {
        label: 'Cancel Delivery Reason',
        path: 'CancelDeliveryReason',
        can: [marketPolicyType.VIEW_CANCEL_DELIVERY_REASONS]
      },
      {
        label: 'Meal Tiers',
        path: 'MealTiersIndex',
        can: [marketPolicyType.VIEW_MEAL_TIERS]
      },
      {
        label: 'Companies',
        path: 'CompaniesList',
        can: [marketPolicyType.VIEW_COMPANIES]
      }
    ]
  },
  {
    label: 'Package',
    icon: 'pi pi-gift',
    key: '14',
    can: [marketPolicyType.VIEW_CANCEL_MEAL_REASONS],
    items: [
      {
        label: 'Package List',
        path: 'PackageList'
      },

      {
        label: 'Package Reason List',
        path: 'CancelPackageReason'
      }
    ]
  },
  {
    label: 'Shipments & Jobs',
    icon: 'pi pi-send',
    key: '2',
    can: [
      marketPolicyType.VIEW_SHIPMENTS,
      marketPolicyType.VIEW_JOBS,
      marketPolicyType.VIEW_CANCEL_SHIPMENT_REASONS
    ],
    items: [
      {
        label: 'Shipment List',
        path: 'ShipmentList',
        can: [marketPolicyType.VIEW_SHIPMENTS]
      },
      {
        label: 'Jobs',
        path: 'JobList',
        can: [marketPolicyType.VIEW_JOBS]
      },
      {
        label: 'Cancel Shipment Reasons',
        path: 'CancelShipmentReason',
        can: [marketPolicyType.VIEW_CANCEL_SHIPMENT_REASONS]
      }
    ]
  },
  {
    label: 'Product Management',
    icon: 'pi pi-box',
    key: '3',
    can: [marketPolicyType.VIEW_ITEMS],
    items: [
      {
        label: 'Items',
        path: 'ItemList',
        can: [marketPolicyType.VIEW_ITEMS]
      },
      {
        label: 'Item Units',
        path: 'ItemUnitList',
        can: [marketPolicyType.VIEW_ITEM_UNITS]
      },
      {
        label: 'Categories',
        path: 'CategoryList',
        can: [marketPolicyType.VIEW_CATEGORIES]
      }
    ]
  },
  {
    label: 'Branch Management',
    icon: 'pi pi-building',
    key: '4',
    can: [
      marketPolicyType.VIEW_VENDERS,
      marketPolicyType.VIEW_BRANCHES,
      marketPolicyType.VIEW_CHANNELS,
      marketPolicyType.VIEW_BRANDS,
      marketPolicyType.VIEW_BRANCH_TAGS,
      marketPolicyType.VIEW_DISABLE_BRANCH_REASONS,
      marketPolicyType.VIEW_BRANCH_DELIVERY_SYSTEMS,
      marketPolicyType.VIEW_BRANCH_MINIMUM_CART_SYSTEMS
    ],
    items: [
      {
        label: 'Branches',
        path: 'BranchList',
        can: [marketPolicyType.VIEW_BRANCHES]
      },

      {
        label: 'Channels',
        path: 'ChannelList',
        can: [marketPolicyType.VIEW_CHANNELS]
      },
      {
        label: 'Trending Search',
        path: 'TrendingSearchList',
        can: [marketPolicyType.VIEW_TRENDING_SEARCHES]
      },
      {
        label: 'Brands',
        path: 'BrandList',
        can: [marketPolicyType.VIEW_BRANDS]
      },
      {
        label: 'Branch Tags',
        path: 'BranchTagList',
        can: [marketPolicyType.VIEW_BRANCH_TAGS]
      },
      {
        label: 'Branch Pins',
        path: 'BranchPinList',
        can: [marketPolicyType.VIEW_BRANCH_PINS]
      },
      {
        label: 'Vendors',
        path: 'VenderList',
        can: [marketPolicyType.VIEW_VENDERS]
      },
      {
        label: 'Disable Branch Reasons',
        path: 'DisabledBranchList',
        can: [marketPolicyType.VIEW_DISABLE_BRANCH_REASONS]
      },
      {
        label: 'Sales Man',
        path: 'SalesMan',
        can: [marketPolicyType.VIEW_SALES_MEN]
      },
      {
        label: 'Branch Delivery System',
        path: 'BranchDeliverySettingList',
        can: [marketPolicyType.VIEW_BRANCH_DELIVERY_SYSTEMS]
      },
      {
        label: 'Branch Minimum Cart System',
        path: 'BranchMinimumCartSystemList',
        can: [marketPolicyType.VIEW_BRANCH_MINIMUM_CART_SYSTEMS]
      },
      {
        label: 'External Branches',
        path: 'ExternalBranchList'
      }
    ]
  },
  {
    label: 'Marketing',
    icon: 'pi pi-tags',
    key: '5',
    can: [
      marketPolicyType.VIEW_DISCOUNTS,
      marketPolicyType.VIEW_COUPONS,
      marketPolicyType.VIEW_CAMPAIGNS,
      marketPolicyType.VIEW_CASHBACK_OFFERS,
      marketPolicyType.VIEW_CARDS,
      marketPolicyType.VIEW_SHOWCASES,
      marketPolicyType.VIEW_CUSTOM_MESSAGES
    ],
    items: [
      {
        label: 'Coupons',
        path: 'Coupons',
        can: [marketPolicyType.VIEW_COUPONS]
      },
      {
        label: 'Campaigns',
        path: 'Campaigns',
        can: [marketPolicyType.VIEW_CAMPAIGNS]
      },
      {
        label: 'Cashback Offers',
        path: 'CashbackOffers',
        can: [marketPolicyType.VIEW_CASHBACK_OFFERS]
      },
      {
        label: 'Discount Offers',
        path: 'DiscountOffer',
        can: [marketPolicyType.VIEW_DISCOUNTS]
      },
      {
        label: 'Cards',
        path: 'CardList',
        can: [marketPolicyType.VIEW_CARDS]
      },
      {
        label: 'Showcase',
        path: 'ShowcaseList',
        can: [marketPolicyType.VIEW_SHOWCASES]
      },
      {
        label: 'Delivery Discounts',
        path: 'DeliveryDiscountList',
        can: [marketPolicyType.VIEW_BRANCH_DELIVERY_DISCOUNT]
      },
      {
        label: 'Prizes',
        path: 'PrizeList',
        can: [marketPolicyType.VIEW_PRIZES]
      },
      {
        label: 'Spin Wheels',
        path: 'SpinWheelList',
        can: [marketPolicyType.VIEW_SPIN_WHEELS]
      },
      {
        label: 'Custom Messages',
        path: 'CustomMessageList',
        can: [marketPolicyType.VIEW_CUSTOM_MESSAGES]
      }
      // {
      //   label: 'Loyalty Program Setting',
      //   path: 'LoyaltyProgramSetting',
      //   can: [marketPolicyType.VIEW_LOYALTY_PROGRAM_SETTINGS]
      // },
      // {
      //   label: 'Loyalty Program Tiers',
      //   path: 'LoyaltyProgramTier',
      //   can: [marketPolicyType.VIEW_LOYALTY_PROGRAM_TIERS]
      // }
    ]
  },
  {
    label: 'Driver Management',
    icon: 'pi pi-car',
    key: '7',
    can: [
      marketPolicyType.VIEW_DRIVERS,
      marketPolicyType.VIEW_DRIVER_TEAMS,
      marketPolicyType.VIEW_DRIVER_BREAKS,
      marketPolicyType.VIEW_DRIVER_DAY_OFFS,
      marketPolicyType.VIEW_DRIVER_PENALTIES,
      marketPolicyType.VIEW_DRIVER_RANKINGS,
      marketPolicyType.VIEW_DRIVER_DAILY_METRICS,
      marketPolicyType.VIEW_DRIVER_METRIC_ADJUSTMENTS,
      marketPolicyType.VIEW_DRIVER_RANK_TIER_CONFIGS,
      marketPolicyType.VIEW_DRIVER_RANK_SETTINGS,
      marketPolicyType.VIEW_DRIVER_EARNING,
      marketPolicyType.VIEW_VEHICLES,
      marketPolicyType.VIEW_SALARY_SYSTEMS,
      marketPolicyType.VIEW_ADJUSTMENTS,
      marketPolicyType.MANAGE_ADJUSTMENT_REASONS
    ],
    items: [
      {
        label: 'Drivers',
        path: 'DriverList',
        can: [marketPolicyType.VIEW_DRIVERS]
      },
      {
        label: 'Driver Ranks',
        path: 'DriverRankingsList',
        can: [
          marketPolicyType.VIEW_DRIVER_RANKINGS,
          marketPolicyType.VIEW_DRIVER_DAILY_METRICS,
          marketPolicyType.VIEW_DRIVER_METRIC_ADJUSTMENTS,
          marketPolicyType.VIEW_DRIVER_RANK_TIER_CONFIGS,
          marketPolicyType.VIEW_DRIVER_RANK_SETTINGS
        ]
      },
      {
        label: 'Driver Earnings',
        path: 'DriverEarningSettingList',
        can: [marketPolicyType.VIEW_DRIVER_EARNING]
      },
      {
        label: 'Driver Teams',
        path: 'DriverTeamList',
        can: [marketPolicyType.VIEW_DRIVER_TEAMS]
      },
      {
        label: 'Driver Breaks',
        path: 'DriverBreakList',
        can: [marketPolicyType.VIEW_DRIVER_BREAKS]
      },
      {
        label: 'Driver Day Offs',
        path: 'DriverDayOffList',
        can: [marketPolicyType.VIEW_DRIVER_DAY_OFFS]
      },
      {
        label: 'Driver Penalties',
        path: 'DriverPenaltyList',
        can: [marketPolicyType.VIEW_DRIVER_PENALTIES]
      },
      {
        label: 'Driver Assignments',
        path: 'DriverAssignments',
        can: [marketPolicyType.VIEW_DRIVERS]
      },
      {
        label: 'Vehicles',
        path: 'VehicleTemplateList',
        can: [marketPolicyType.VIEW_VEHICLES]
      },
      {
        label: 'Salary System',
        path: 'SystemSalaryList',
        can: [marketPolicyType.VIEW_SALARY_SYSTEMS]
      },
      {
        label: 'Adjustment',
        path: 'Adjustment',
        can: [marketPolicyType.VIEW_ADJUSTMENTS]
      },
      {
        label: 'Adjustment Reasons',
        path: 'AdjustmentReason',
        can: [marketPolicyType.MANAGE_ADJUSTMENT_REASONS]
      }
    ]
  },
  {
    label: 'Pouch',
    icon: 'pi pi-credit-card',
    key: '8',
    can: [
      marketPolicyType.VIEW_DRIVER_POUCHES,
      marketPolicyType.VIEW_ACCOUNTANT_POUCHES,
      marketPolicyType.VIEW_DRIVER_POUCH_OPERATIONS
    ],
    items: [
      {
        label: 'Driver Pouches',
        path: 'DriverPouchList',
        can: [marketPolicyType.VIEW_DRIVER_POUCHES]
      },
      {
        label: 'Accountant Pouches',
        path: 'AccountantPouchList',
        can: [marketPolicyType.VIEW_ACCOUNTANT_POUCHES]
      },
      {
        label: 'Driver Halts',
        path: 'DriverHaltList',
        can: [marketPolicyType.VIEW_DRIVER_HALTS]
      },
      {
        label: 'System Wallet',
        path: 'SystemWallet',
        can: [marketPolicyType.VIEW_DRIVER_POUCH_OPERATIONS]
      }
    ]
  },

  {
    label: 'Shifts',
    icon: 'pi pi-clock',
    key: '9',
    can: [
      marketPolicyType.VIEW_DRIVER_SHIFTS,
      marketPolicyType.VIEW_SHIFT_TEMPLATES,
      marketPolicyType.VIEW_SHIFT_SETTINGS
    ],
    items: [
      {
        label: 'Shift List',
        path: 'ShiftList',
        can: [marketPolicyType.VIEW_DRIVER_SHIFTS]
      },
      {
        label: 'Shift Calendar',
        path: 'ShiftCalendar',
        can: [marketPolicyType.VIEW_DRIVER_SHIFTS]
      },
      {
        label: 'Shift Templates',
        path: 'ShiftTemplate',
        can: [marketPolicyType.VIEW_SHIFT_TEMPLATES]
      },

      {
        label: 'Shift Settings',
        path: 'ShiftSetting',
        can: [marketPolicyType.VIEW_SHIFT_SETTINGS]
      }
    ]
  },
  {
    label: 'User Management',
    icon: 'pi pi-user',
    key: '10',
    can: [
      marketPolicyType.VIEW_USERS,
      marketPolicyType.VIEW_USER_ROLES,
      marketPolicyType.VIEW_BASE_ROLES,
      marketPolicyType.VIEW_CHANNEL_USERS,
      marketPolicyType.VIEW_GROUPS
    ],
    items: [
      {
        label: 'Users',
        path: 'UserList',
        can: [marketPolicyType.VIEW_USERS]
      },
      {
        label: 'User Groups',
        path: 'UserGroupList',
        can: [marketPolicyType.VIEW_GROUPS]
      },
      {
        label: 'Roles',
        path: 'Role',
        can: [marketPolicyType.VIEW_USER_ROLES]
      },
      {
        label: 'Base Roles',
        path: 'BaseRole',
        can: [marketPolicyType.VIEW_BASE_ROLES]
      },
      {
        label: 'Channel Users',
        path: 'ChannelUser',
        can: [marketPolicyType.VIEW_CHANNEL_USERS]
      }
    ]
  },
  {
    label: 'Setting',
    icon: 'pi pi-cog',
    key: '11',
    can: [
      marketPolicyType.VIEW_SERVICES,
      marketPolicyType.VIEW_DISTRICTS,
      marketPolicyType.VIEW_TRANSLATIONS,
      marketPolicyType.VIEW_PANEL_SETTINGS,
      marketPolicyType.VIEW_MEAL_TIERS,
      marketPolicyType.VIEW_REMINDER_SETTINGS,
      marketPolicyType.VIEW_MENU_SCREENS
    ],
    items: [
      {
        label: 'Services',
        path: 'Service',
        can: [marketPolicyType.VIEW_SERVICES]
      },
      {
        label: 'Region Delivery Range Setting',
        path: 'RegionDeliveryRangeSetting',
        can: [marketPolicyType.VIEW_REGION_DELIVERY_RANGE_SETTINGS]
      },
      {
        label: 'Districts',
        path: 'DistrictList',
        can: [marketPolicyType.VIEW_DISTRICTS]
      },
      {
        label: 'Translations',
        path: 'Translation',
        can: [marketPolicyType.VIEW_TRANSLATIONS]
      },
      {
        label: 'Panel Settings',
        path: 'PanelSetting',
        can: [marketPolicyType.VIEW_PANEL_SETTINGS]
      },
      {
        label: 'Driver Menu Config',
        path: 'DriverMenuConfig',
        can: [marketPolicyType.VIEW_MENU_SCREENS]
      },
      {
        label: 'Order Payment Types',
        path: 'OrderPaymentType'
      },
      {
        label: 'Reminder Setting',
        path: 'ReminderSetting',
        can: [marketPolicyType.VIEW_REMINDER_SETTINGS]
      },
      {
        label: 'Zoho',
        path: 'Zoho'
      }
    ]
  }
]
